/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Adr_Enable_Midi_HelpInputs */

const en_options_adr_enable_midi_help = /** @type {(inputs: Options_Adr_Enable_Midi_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable or disable MIDI control with external applications (e.g. Avid ProTools). This feature is intended to help when recording AD and DV scripts. Contact Support for more information.`)
};

const fr_options_adr_enable_midi_help = /** @type {(inputs: Options_Adr_Enable_Midi_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activer ou désactiver le contrôle MIDI avec des applications externes (ex. Avid ProTools). Cette fonctionnalité aide lors de l'enregistrement de scripts AD et DV. Contactez le support pour plus d'informations.`)
};

const de_options_adr_enable_midi_help = /** @type {(inputs: Options_Adr_Enable_Midi_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivieren oder deaktivieren Sie die MIDI-Steuerung für externe Anwendungen (z. B. Avid Pro Tools). Diese Funktion ist für die Aufnahme von AD- und DV-Skripten gedacht. Weitere Informationen erhalten Sie vom Support.`)
};

const it_options_adr_enable_midi_help = /** @type {(inputs: Options_Adr_Enable_Midi_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abilita o disabilita il controllo MIDI con applicazioni esterne (ad esempio Avid ProTools). Questa funzione è pensata per facilitare la registrazione di script AD e DV. Contatta l'assistenza per ulteriori informazioni.`)
};

const ru_options_adr_enable_midi_help = /** @type {(inputs: Options_Adr_Enable_Midi_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Включение или отключение управления MIDI с помощью внешних приложений (например, Avid ProTools). Эта функция предназначена для помощи при записи сценариев AD и DV. Для получения дополнительной информации обратитесь в службу поддержки.`)
};

const es_options_adr_enable_midi_help = /** @type {(inputs: Options_Adr_Enable_Midi_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilite o deshabilite el control MIDI con aplicaciones externas (p. ej., Avid ProTools). Esta función facilita la grabación de scripts de AD y DV. Para más información, contacte con el soporte técnico.`)
};

const zh_cn2_options_adr_enable_midi_help = /** @type {(inputs: Options_Adr_Enable_Midi_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启用或禁用与外部应用程序（例如 Avid Pro Tools）的 MIDI 控制。此功能旨在帮助录制 AD 和 DV 脚本。请联系技术支持了解更多信息。`)
};

const ja_options_adr_enable_midi_help = /** @type {(inputs: Options_Adr_Enable_Midi_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`外部アプリケーション（例：Avid ProTools）によるMIDIコントロールを有効または無効にします。この機能は、ADおよびDVスクリプトの記録時に役立ちます。詳細については、サポートにお問い合わせください。`)
};

const hi_options_adr_enable_midi_help = /** @type {(inputs: Options_Adr_Enable_Midi_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बाहरी एप्लिकेशन (जैसे कि Avid ProTools) के साथ MIDI नियंत्रण को सक्षम या अक्षम करें। यह सुविधा AD और DV स्क्रिप्ट रिकॉर्ड करते समय सहायता प्रदान करती है। अधिक जानकारी के लिए सहायता टीम से संपर्क करें।`)
};

const pt_pt2_options_adr_enable_midi_help = /** @type {(inputs: Options_Adr_Enable_Midi_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ative ou desative o controle MIDI com aplicativos externos (por exemplo, Avid Pro Tools). Este recurso foi desenvolvido para auxiliar na gravação de scripts AD e DV. Entre em contato com o suporte para obter mais informações.`)
};

/**
* | output |
* | --- |
* | "Enable or disable MIDI control with external applications (e.g. Avid ProTools). This feature is intended to help when recording AD and DV scripts. Contact Su..." |
*
* @param {Options_Adr_Enable_Midi_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_adr_enable_midi_help = /** @type {((inputs?: Options_Adr_Enable_Midi_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Adr_Enable_Midi_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_adr_enable_midi_help(inputs)
	if (locale === "de") return de_options_adr_enable_midi_help(inputs)
	if (locale === "it") return it_options_adr_enable_midi_help(inputs)
	if (locale === "ru") return ru_options_adr_enable_midi_help(inputs)
	if (locale === "es") return es_options_adr_enable_midi_help(inputs)
	if (locale === "zh-CN") return zh_cn2_options_adr_enable_midi_help(inputs)
	if (locale === "ja") return ja_options_adr_enable_midi_help(inputs)
	if (locale === "hi") return hi_options_adr_enable_midi_help(inputs)
	if (locale === "pt-PT") return pt_pt2_options_adr_enable_midi_help(inputs)
	return en_options_adr_enable_midi_help(inputs)
});